import { Component, Input, OnInit } from '@angular/core';
import { StatsDataDetails } from '../../due-diligence/model/StatsDataDetails';
import { StatsDataService } from 'src/app/services/stats-data.service';

@Component({
  standalone: false,
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.css']
})
export class HeaderTitleComponent implements OnInit {

  @Input() lenderName: string = '';
  @Input() sellerServicerNumber: any;

  noAcquisitions: any = 0;
  rateCompliance: any = 0;
  rateSubmission: any = 0;

  isNotNumber: boolean = false;
  isNotNumberAcquisitions: boolean = false;
  userId: string;

  constructor(private statsDataService: StatsDataService) {
    this.statsDataService.statsDataDetailsSub.subscribe((statsDataDetails: StatsDataDetails) => {
      if (statsDataDetails) {
        // console.log('HeaderTitleComponent statsDataDetails: update stats with ', statsDataDetails);

        this.noAcquisitions = statsDataDetails.noAcquisitions;
        this.rateCompliance = statsDataDetails.rateCompliance;
        this.rateSubmission = statsDataDetails.rateSubmission;

        if (isNaN(this.noAcquisitions)) {
          this.isNotNumberAcquisitions = true;
        } else {
          this.isNotNumberAcquisitions = false;
        }

        if (isNaN(this.rateSubmission)) {
          this.isNotNumber = true;
        } else {
          this.isNotNumber = false;
        }
      }
    });
  }

  ngOnInit(): void {
  }
}
